import router from '../router';

export default class {
    public pageLoader = function() {};
    public totalCount = 0;
    public currentPage = 1;
    public itemsPerPage = 50;
    public totalPageCount = 0;
    public isInfinite = false; // in infinite mode total count has a hard limit, let's say 10000 items,
    //but the paginator will allow use to go other the last page to see the other items
    public offset = 0;
    public paginationCacheKeys = {}; //saves cache key for totalCount
    public routeName = router.currentRoute.value.name;
    public routeFunc;

    constructor(route?: any) {
        if (typeof route == 'function') {
            this.routeFunc = route;
        }
    }

    public doCalculations() {
        this.totalPageCount = Math.ceil(this.totalCount / this.itemsPerPage);

        if (this.currentPage < 1) {
            this.setPage(1);
            return;
        }
        if (!this.isInfinite && this.totalPageCount > 0 && this.currentPage > this.totalPageCount) {
            this.setPage(this.totalPageCount);
            return;
        }

        this.offset = (this.currentPage - 1) * this.itemsPerPage;
    };

    public setPage(pageNumber) {
        if (this.currentPage != pageNumber) {
            this.currentPage = parseInt(pageNumber);
            this.doCalculations();
        }
    };

    public setTotalItemCount(totalItemCount) {
        this.totalCount = totalItemCount;
        this.doCalculations();
    };

    public setItemsPerPage(maxItems) {
        this.itemsPerPage = maxItems;
        this.doCalculations();
    };

    public goToPage = (pageNum) => {
        const obj = {
            query: Object.assign(
                {},
                router.currentRoute.value,
                {page: pageNum}
            )
        };
        if (this.routeName) {
            obj["name"] = this.routeName;
        }
        return obj;
    }

    public getCacheValue(key) {
        let value = null;

        if (typeof this.paginationCacheKeys[key] != 'undefined' && Object.keys(this.paginationCacheKeys[key]).length > 0) {
            if (typeof this.paginationCacheKeys[key]['value'] != 'undefined' && typeof this.paginationCacheKeys[key]['timestamp'] != 'undefined' && (((Date.now() / 1000) - this.paginationCacheKeys[key]['timestamp']) < 5 * 60)) {
                value = this.paginationCacheKeys[key]['value'];
            }
        }

        return value;
    };

    public setCacheValue(key, value) {
        this.paginationCacheKeys[key] = {};
        this.paginationCacheKeys[key]['timestamp'] = Date.now() / 1000;
        this.paginationCacheKeys[key]['value'] = value;
    };

    public clearCacheValue(key?:any) {
        if (key) {
            this.paginationCacheKeys[key] = {};
        } else {
            this.paginationCacheKeys = {};
        }
    };
}
